import { VF_DATE_PICKER } from 'AppSrc/core/components/forms/form-base-components/v-f-date-picker';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
// import {
//   // FIXED,
//   MOBILE,
// } from 'AppSrc/core/components/forms/value-dependency-constants';
import { PEER_APPROVED_TYPE } from 'AppSrc/core/components/forms/form-types/create-crq/section-five/work-information-items/work-information-item-constants';
// Key values that are repeated a lot
import { getWiiMetadata } from 'AppSrc/core/components/forms/form-types/create-crq/section-five/work-information-items/work-information-item-logic';
import { DEFAULT_TIMEZONE } from 'AppSrc/core/utility-functions/date-functions';
import moment from 'moment-timezone';
import {
  isCrqEmergency,
  getIsInternationalCrq,
  getIsOlaCrq,
  currentSelectedNetwork,
} from '../common-logic';

const fieldId = 'scheduled-start-date';

const hasEmergenctL3Approvalwii = (formData, selectedNetwork) => {
  if (!formData) { return false; }
  const wiis = getWiiMetadata(formData);
  const approvalType = PEER_APPROVED_TYPE[selectedNetwork];
  return wiis.some((wii) => wii.type === approvalType);
};

const validator = (params) => {
  const {
    values,
    field,
    formData,
  } = params;
  const {
    optional,
  } = field;
  const value = values[fieldId];
  const isEmergency = isCrqEmergency(formData);
  const isInternational = getIsInternationalCrq(formData);
  const isOloCrq = getIsOlaCrq(formData);
  const selectedNetwork = currentSelectedNetwork(formData);



  const minDate = field.componentData.vFParams.minDate;
  const dateIsBeforeMin = commonValidation.date.isBeforeMinDate(value, minDate);
  const changeQuestions = 'CHANGE_QUESTIONS';
  const isSlaEmergency = params.formData.dataByFormSectionId[changeQuestions].dataByFieldId.timing.value[0];
  const statusReason = params.formData.statusReason;
  const isEmergency2ndJourney = isEmergency && ((statusReason === '30300' || statusReason === 'PostponedCRQ') || hasEmergenctL3Approvalwii(formData, selectedNetwork));

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(value, VF_DATE_PICKER);


  // Scheduled start date validation for emergency CRQs
  if ((selectedNetwork === 'fixed' || isOloCrq || isInternational) && isEmergency) {
    const minTime = moment.tz(DEFAULT_TIMEZONE).add(15, 'minutes');
    const maxTime = moment.tz(DEFAULT_TIMEZONE).add(48, 'hours');
    const thisMoment = moment.tz(value, DEFAULT_TIMEZONE).startOf('minute');

    const lessThanFifteenMinutes = thisMoment.isBefore(minTime);
    const moreThanFortyEightHours = thisMoment.isAfter(maxTime);

    if (lessThanFifteenMinutes && isEmergency2ndJourney === false) {
      errors[INLINE_ERRORS].push('Start date/time cannot be less than 15 minutes from now');
    }
    else if (moreThanFortyEightHours) {
      errors[INLINE_ERRORS].push('Start date/time cannot be more than 48 hours');
    }
  }
  if (selectedNetwork === 'mobile' && isEmergency) {
    const minTime = moment.tz(DEFAULT_TIMEZONE).add(15, 'minutes');
    const maxTime = moment.tz(DEFAULT_TIMEZONE).add(2, 'hours');
    const thisMoment = moment.tz(value, DEFAULT_TIMEZONE).startOf('minute');

    const lessThanFifteenMinutes = thisMoment.isBefore(minTime);
    const moreThanTwoHours = thisMoment.isAfter(maxTime);

    if (lessThanFifteenMinutes && isEmergency2ndJourney === false) {
      errors[INLINE_ERRORS].push('Start date/time cannot be less than 15 minutes from now');
    }
    else if (moreThanTwoHours) {
      errors[INLINE_ERRORS].push('Start date/time cannot be more than 2 hours');
    }
  }

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select an option' : null);
  // We are not showing this error on 2nd journey of L3 Approval i.e when Emergency CRQ is moved back to Planning in progress stage after getting L3 approved
  // as coordinator should be able to change end date and submit the CRQ. We are doing this here based on if timing is Emergency in formdata and status reason is postponed
  // we have used status reason logic here as there is no postpone scenario separately for Emergency, so only in this case Emergency CRQ will have this status reason.
  errors[INLINE_ERRORS].push((dateIsBeforeMin && (isSlaEmergency !== '2000' && isSlaEmergency !== 'Emergency') && (statusReason !== '30300' && statusReason !== 'PostponedCRQ')) ? 'Due to the risk level, a later date is needed than the one selected' : null);
  // errors[INLINE_ERRORS].push(dateIsBeforeMin ? 'Due to the risk level, a later date is needed than the one selected' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

// This overwritten by the form :)
const initialValues = null;

const vFParams = {
  fieldTitle: 'Scheduled start date/time',
  displayType: 'big',
};

const scheduledStartDate = {
  id: fieldId,
  validator,
  vFParams,
  initialValues,
  fieldType: VF_DATE_PICKER,
};

export { scheduledStartDate };
